import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "count", "bulkBtn", "snoozeBtn"]
  static values = { bulkPromoteUrl: String, bulkSnoozeUrl: String, csrf: String }

  connect() {
    this.selected = new Set()
    console.log("[promotion-select] connected", { rows: this.rowTargets.length })
    this.render()
  }

  toggle(event) {
    if (event.target.closest("a, button, form, [data-no-select]")) return

    const id = event.currentTarget.dataset.progressId
    if (!id) return

    if (this.selected.has(id)) {
      this.selected.delete(id)
    } else {
      this.selected.add(id)
    }
    this.render()
  }

  selectAll() {
    if (this.selected.size === this.rowTargets.length) {
      this.selected.clear()
    } else {
      this.rowTargets.forEach(r => { if (r.dataset.progressId) this.selected.add(r.dataset.progressId) })
    }
    this.render()
  }

  submitBulkPromote() {
    if (this.selected.size === 0) return
    const n = this.selected.size
    if (!confirm(`Promote ${n} member${n === 1 ? "" : "s"} to their target rank?`)) return
    this._submitBulk(this.bulkPromoteUrlValue)
  }

  submitBulkSnooze(event) {
    if (this.selected.size === 0) return
    const months = event.currentTarget.dataset.months || "3"
    const n = this.selected.size
    if (!confirm(`Snooze ${n} member${n === 1 ? "" : "s"} for ${months} months?`)) return

    const date = new Date()
    date.setMonth(date.getMonth() + parseInt(months))
    const untilDate = date.toISOString().split("T")[0]

    this._submitBulk(this.bulkSnoozeUrlValue, { until_date: untilDate })
  }

  _submitBulk(url, extraParams = {}) {
    const form = document.createElement("form")
    form.method = "POST"
    form.action = url
    form.style.display = "none"

    const csrf = document.createElement("input")
    csrf.type = "hidden"
    csrf.name = "authenticity_token"
    csrf.value = this.csrfValue
    form.appendChild(csrf)

    this.selected.forEach(id => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "progress_ids[]"
      input.value = id
      form.appendChild(input)
    })

    Object.entries(extraParams).forEach(([key, value]) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = key
      input.value = value
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }

  render() {
    const count = this.selected.size
    const total = this.rowTargets.length

    if (this.hasCountTarget) {
      this.countTarget.textContent = count > 0 ? `${count} of ${total} selected` : `Select all (${total})`
    }

    if (this.hasBulkBtnTarget) {
      this.bulkBtnTarget.disabled = count === 0
      this.bulkBtnTarget.textContent = count > 0 ? `Promote Selected (${count})` : "Promote Selected"
    }

    if (this.hasSnoozeBtnTarget) {
      this.snoozeBtnTarget.disabled = count === 0
      this.snoozeBtnTarget.textContent = count > 0 ? `Snooze Selected (${count})` : "Snooze Selected"
    }

    this.rowTargets.forEach(row => {
      const id = row.dataset.progressId
      const on = this.selected.has(id)
      const icon = row.querySelector("[data-select-icon]")

      row.classList.toggle("ring-2", on)
      row.classList.toggle("ring-primary-500/30", on)

      if (icon) {
        icon.innerHTML = on
          ? '<svg class="size-7 text-primary-500" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" /></svg>'
          : '<svg class="size-7 text-gray-300 dark:text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9.75" /></svg>'
      }
    })
  }
}
